import { RadioGroupNew, RadioButtonNew } from "@octopusdeploy/design-system-components";
import type { TaskResource } from "@octopusdeploy/octopus-server-client";
import React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { ExpandableFormSection, Note, Summary } from "~/components/form";
import { TriggerSyncTask } from "./TriggerSyncTask";
type CommunityActionTemplatesFeatureProps = {
    isEnabled: boolean;
    isSyncEnabled: boolean;
    lastSyncedTask?: TaskResource<{}>;
    busy?: Promise<unknown> | boolean;
    onChange: (isEnabled: boolean) => void;
    onSyncClick: () => void;
};
export function CommunityActionTemplatesFeature({ isEnabled, isSyncEnabled, lastSyncedTask, busy, onChange, onSyncClick }: CommunityActionTemplatesFeatureProps) {
    const description = "Enable access to the Community Library.";
    const label = "Community Step Templates";
    const name = "CommunityActionTemplates";
    return (<ExpandableFormSection key="IsCommunityActionTemplatesEnabled" errorKey="IsCommunityActionTemplatesEnabled" title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>

            <TriggerSyncTask isSyncEnabled={isSyncEnabled} lastSyncedTask={lastSyncedTask} busy={busy} onSyncClick={onSyncClick}/>
            <Note>
                <p>
                    This feature requires internet to access the <ExternalLink href="CommunityLibrary">Community Library</ExternalLink>. Octopus will fetch and store the
                    <ExternalLink href="CommunityContributedStepTemplates"> community contributed steps</ExternalLink> locally, to be available when creating a deployment process and step templates.
                </p>
            </Note>
        </ExpandableFormSection>);
}
